import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Select as MuiSelect, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material';

class Select extends Component {
	constructor(props) {
		super(props);
	}

	getMenuItems = () => {
		if (this.props.dataType === 'assignmentTypes') {
			return (
				this.props.options.map((item, i) => (
					<MenuItem key={item.id} value={item.id}>{item.value}</MenuItem>
				))
			);
		} else if (this.props.dataType == 'assignment') {
			return this.props.status.assignmentStatus.map((item, i) => {
				if (item.selectable) {
					return (
						<MenuItem key={item.id} value={item.id}>{item.value}</MenuItem>
					);
				}
			});
		} else if (this.props.dataType == 'assignmentStatus') {
			return this.props.options.map((item, i) => {
				if (item.selectable) {
					return (
						<MenuItem key={item.id} value={item.id}>{item.value}</MenuItem>
					);
				}
			});
		} else if (this.props.dataType == 'plan') {
			return this.props.options.map((item, i) => {
				return (
					<MenuItem key={item.id} value={item.id}>{item.value}</MenuItem>
				);
			});
		} else if (this.props.dataType == 'assignment-plan') {
			return this.props.options.map((item, i) => {
				return (
					<MenuItem key={item.id} value={item.id}>{item.title}</MenuItem>
				);
			});
		}
		else if (this.props.dataType == 'groups-selector') {
			return this.props.options.map((item, i) => (
				<MenuItem key={item.id} value={item.id}>{item.title}</MenuItem>
			));
		}

		return (
			this.props.options.map((item, i) => (
				<MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
			))
		);
	}

	getPlaceholderValue = () => {
		if (this.props.placeholder) {
			let selectValue = '0';

			if (this.props.placeholderValue !== undefined) {
				selectValue = this.props.placeholderValue;
			} else if (this.props.placeholderValue === '') {
				selectValue = this.props.placeholderValue;
			}

			return selectValue;
		}
		return '';
	}

	getPlaceholderText = () => {
		if (this.props.placeholder) {
			if (this.props.placeholder != null && this.props.placeholder != '' && !this.props.placeholder) {
				return this.props.placeholder;
			}

			return this.props.translate('select-an-alternative');
		}
		return '';
	}

	onChange = (event) => {
		if (this.props.onChange != null && typeof this.props.onChange == 'function') {
			this.props.onChange(event);
		}

		if (this.props.input != null) {
			if (this.props.input.onChange != null && typeof this.props.input.onChange == 'function') {
				this.props.input.onChange(event.target.value);
			}
		}
	}

	render() {
		const { label, name, id, input, selectedValue, disabled, meta, style } = this.props;

		// Prefer a controlled select to avoid switching between controlled/uncontrolled
		// which can cause native select UIs (like Teams webview on macOS) to close.
		const controlledValue = (input && input.value !== undefined && input.value !== null)
			? input.value
			: (selectedValue !== undefined && selectedValue !== null ? selectedValue : '');

		const placeholderValue = this.getPlaceholderValue();
		const placeholderText = this.getPlaceholderText();
		const hasError = meta && meta.touched && meta.error;

		return (
			<FormControl
				fullWidth
				size="small"
				error={hasError}
				style={style}
			>
				{label && <InputLabel id={`${name}-label`}>{label}</InputLabel>}
				<MuiSelect
					sx={{ backgroundColor: '#FFFFFF' }}
					labelId={label ? `${name}-label` : undefined}
					name={name}
					id={id ? id : name}
					disabled={disabled}
					value={controlledValue}
					onChange={this.onChange}
					label={label}
				>
					{placeholderText && (
						<MenuItem value={placeholderValue}>
							{placeholderText}
						</MenuItem>
					)}
					{this.getMenuItems()}
				</MuiSelect>
				{hasError && (
					<FormHelperText>{meta.error}</FormHelperText>
				)}
				{meta && meta.touched && meta.warning && !meta.error && (
					<FormHelperText>{meta.warning}</FormHelperText>
				)}
			</FormControl>
		);
	}
}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
		status: state.status.status,
	};
}


export default connect(mapStateToProps)(Select);
